<template>
  <v-select
    :name="name"
    :value="value"
    @input="emitInput"
    @change="emitChange"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    @keyup="$emit('keyup')"
    :error-messages="errorMessages"
    :disabled="disabled"
    :items="items"
    :item-value="itemValue"
    :item-text="itemText"
    :item-disabled = "disableItem"
    :menu-props="{bottom: true, offsetY: true}"
    :class="elementClass"
    :multiple="multiple"
    :label="label"
    :placeholder="placeholder"
    solo
    append-icon
    ref="select">
    <template v-if="showSelectAll && buttonSlot !== 'prepend-item'" slot="prepend-item">
      <v-list-item @click="$emit('selectAll')" :class="selectAllClass + ' ' + colorClass">
      <v-icon 
        class="mr-3" 
        size="18px" 
        v-if="multiple" 
        :class="colorClass">
        far fa{{selectAllIcon}}-square</v-icon>
        <span :class="colorClass">(Un)Select All {{itemName}}s</span>
      </v-list-item>
    </template>
    
    <template slot="item" slot-scope="props">
      <v-icon class="mr-3" v-if="multiple" size="18px">
         far fa{{iconText(props)}}-square
        </v-icon>
      <v-icon v-if="props.item[itemIcon]" class="mr-2" size="18px">{{props.item[itemIcon]}}</v-icon>
        <span :class="colorClass"><span class="selectItem">{{props.item[itemText] || props.item}}</span></span>
    </template>

    <template slot="selection" slot-scope="{item, index}">
      <span :class="colorClass" v-if="selectionPrefix && index === 0" class="mr-2">{{selectionPrefix}}</span>
      <span :class="colorClass" v-if="collapsedWhenMultiple && index === 0">
        <v-icon v-if="item[itemIcon]" class="mr-2" color="black">{{item[itemIcon]}}</v-icon>
        <span :class="colorClass" v-if="allSelected">All {{itemName}}s</span>
        <span :class="colorClass" v-else-if="value.length > 1">{{value.length}} {{itemName}}s</span>
        <span :class="colorClass" v-else>{{item[itemText] || item}}</span>
      </span>
      <span :class="colorClass" v-else-if="!collapsedWhenMultiple">
        <v-icon v-if="item[itemIcon]" class="mr-2" color="black">{{item[itemIcon]}}</v-icon>
        <span :class="colorClass" v-else class="mr-1">{{item[itemText] || item}}</span>
      </span>
    </template>

    <template :slot="buttonSlot">
      <image-button
          class="select-button"
          icon
          @click="openSelectMenu"
          :disabled="disabled"
          :image="coloredAssetUrls.dropdown"/>
    </template>
  </v-select>
</template>

<script>
import imageButton from "./ImageButton";

export default {
  name: "selectWithButton",
  components: { imageButton },
  props: {
    value: [String, Array, Number, Boolean, Object],
    name: String,
    items: Array,
    itemValue: { type: String, default: "value" },
    itemText: { type: String, default: "text" },
    itemIcon: { type: String, default: "icon" },
    errorMessages: Array,
    disabled: Boolean,
    iconButton: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    label: String,
    buttonSlot: {type: String, default: "append-outer" },
    showSelectAll: Boolean,
    selectionPrefix: String,
    itemName: String,
    collapsedWhenMultiple: Boolean,
    placeholder: String
  },
  methods: {
    openSelectMenu() {
      // note: onClick({}) is a weird hack required as of vue 2.2.8. This deserves research to remove
      if (this.$refs.select.isFocused)
        this.$refs.select.blur();
      else
        this.$refs.select.onClick({});
    },
    emitChange(selectValue) {
      this.$emit("change", selectValue);
    },
    emitInput(selectValue) {
      if(!this.multiple){
        this.$refs.select.blur();
      }
      this.$emit("input", selectValue);
    },
    itemSelected(item){ 
      return (this.value !== undefined) && (this.value.includes(item) || this.value.includes(item.value) || this.value.includes(item.phySrNo));
    },
    iconText(props){
      return this.itemSelected(props.item) ? "-check" : "";
    },
    disableItem (item){
      if(item.disabled && item.disabled === true){
        return true;
      }else{
        false;
      }
    } 
  },
  computed: {
    elementClass() {
      let classes = [
        "select-input", 
        this.class, 
        this.iconButton && "icon-button"
      ].filter(v => v).join(" ");
      return classes;
    },
    allSelected(){
      return  (this.value !== undefined) && (this.value.length === this.items.length);
    },
    selectAllIcon(){
      return this.allSelected ? "-check" : "";
    },
    selectAllClass(){
      return {"primary--text v-list-item--active": this.allSelected};
    }
  }
};
</script>
<style lang="scss" scoped>
  .v-list-item--disabled{
    span.selectItem{
      color: #c5c5c5 !important;
    }
  }
</style>
